<script context="module">
	import { writable } from 'svelte-persistent-store/dist/local'

	export const token = writable('token', '')
	export const config = {
		apiurl: 'https://api.deckronomicon.com',
	}
</script>
